<div style="display: inline;">
    <div class="minibar minibar--mini">
        <div class="minibar__bar" *ngFor="let c of data">
          <span class="minibar__tooltip">{{ c.fecha }}</span>
          <div class="minibar__fill" [style.height.%]="c.bateria"></div>
        </div>
    </div>
</div>

